import { Component, OnInit, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';
import { LanguageService } from './services/language/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly swUpdate = inject(SwUpdate);
  private readonly snackBar = inject(MatSnackBar);
  private readonly language = inject(LanguageService);
  private readonly translate = inject(TranslateService);

  ngOnInit(): void {
    this.language.initialize();
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(
        filter(
          (event): event is VersionReadyEvent =>
            event.type === 'VERSION_READY',
        ),
      )
      .subscribe(() => {
        const ref = this.snackBar.open(
          this.translate.instant('app.updateAvailable'),
          this.translate.instant('app.update'),
          { duration: 0 },
        );
        ref.onAction().subscribe(() => {
          this.swUpdate
            .activateUpdate()
            .then(() => document.location.reload());
        });
      });
  }
}
